import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { shareReplay } from 'rxjs';
import { Filter } from '../../all-tournaments/store/actions/allTournaments.action';
import { endpoints } from '../../utils/endpoints';
import { ProfileUpdateTeamRequest } from '../models/api/requests/team.request';
import {
    ProfileTeamResponse,
    TeamTournamentsWithPagination,
} from '../models/api/responses/team.response';
import { ProfileStatistics } from '../../profile/models/api/responses/profileGeneral.response';

@Injectable({
    providedIn: 'root',
})
export class ProfileTeamsService {
    private http = inject(HttpClient);


    getTeam(teamId: string) {
        return this.http
            .get<ProfileTeamResponse>(
                endpoints.teams.children.getTeamUrl(teamId)
            )
            .pipe(shareReplay());
    }

    fetchTeamTournaments(teamId: string, page: number, filter: Filter) {
        return this.http
            .get<TeamTournamentsWithPagination>(
                endpoints.teams.children.getTeamTournamentsUrl(
                    teamId,
                    page,
                    filter
                )
            )
            .pipe(shareReplay());
    }

    fetchTeamStatistics(teamId: string) {
        return this.http
            .get<ProfileStatistics>(
                endpoints.teams.children.getTeamStatistics(teamId)
            )
            .pipe(shareReplay());
    }

    removeMember(teamId: string, playerId: string) {
        return this.http.delete<unknown>(
            endpoints.teams.children.getRemoveMemberUrl(teamId, playerId)
        );
    }

    leaveTeam(teamId: string) {
        return this.http.delete<unknown>(
            endpoints.teams.children.getLeaveTeamUrl(teamId)
        );
    }

    transferLeadership(teamId: string, playerId: string) {
        return this.http.put<ProfileTeamResponse>(
            endpoints.teams.children.putLeadershipUrl(teamId, playerId),
            {}
        );
    }

    updateTeam(teamId: string, request: ProfileUpdateTeamRequest) {
        return this.http.put<ProfileTeamResponse>(
            endpoints.teams.children.getTeamUrl(teamId),
            request
        );
    }
}
